
	$.ajax({
		url: 'http://www.bilibili.com/index/promote/64.json',
		type: 'get',
		dataType: 'json',
		async:false,
		success : function(data){
			data = data || {};
			$('.about-video').biliSlider({
					data: data.item,
					type: 'showcase',
					timeout: 5000,
					stepLength: 5,
					onRender:function(wrapper, data, index){
						$(wrapper).find('li[index=' + index + ']').attr('data-aid', data.width);
						$(wrapper).find('li[index=' + index + ']').find('img').attr('data-aid', data.width);
					}
				});
			if(data.item.length <= 5){
				$('.about-video').find('.slider-bottom,.slider-next,.slider-prev').css('display', 'none');
			}else{
				$('.about-video').find('.slider-bottom,.slider-next,.slider-prev').css('display', 'block');
			}
		}
	})


	$.ajax({
		url: 'http://www.bilibili.com/index/promote/65.json',
		type: 'get',
		dataType: 'json',
		async:false,
		success : function(data){
			data = data || {};
			// data.item.length = 0;
			if(data.item.length < 1){
				$('.left-cont .guest-part').css('display', 'none');
			}
			$('.left-cont .guest').biliSlider({
				data: data.item,
				type: 'gallery',
				timeout:0,
				onRender:function(wrapper, data, index){
					var block = '<div class="intro">\
									<p class="intro-p1">tgs：<span class="video-name">'+data.title+'</span></p>\
									<p class="intro-p2">UP：<span class="up-name">'+data.link+'</span></p>\
								</div>';
					var slider_li = $(wrapper).find('.slider-list-wrapper').find('li[index=' + index + ']');
					slider_li.append(block);
					slider_li.attr('data-aid', data.width);
					slider_li.find('img').attr('data-aid', data.width);

					var text = '<p class="name">'+data.link+'</p>';
					$(wrapper).find('.s-bottom').find('li[index=' + index + ']').append(text);
				},
		        slideCallback: function(wrapper, index) {
			        var sbar = $('.slider-bar',wrapper),
						box = $('.slider-bar li',wrapper),
						thisBox = box.eq(index),
						boxWidth = box.width();
			        if (thisBox.position().left > 0) {
			            sbar.css('left','-' + thisBox.position().left + 'px');
			        }
		        }

			});
			var arrow = $('.left-cont .guest').find('.slider-prev,.slider-next');
			if(data.item.length <= 1){
				arrow.css('display', 'none');
			}else{
				arrow.css('display', 'block');
			}

		}
	})

	$.ajax({
		url: 'http://www.bilibili.com/index/promote/66.json',
		type: 'get',
		dataType: 'json',
		async:false,
		success : function(data){
			data = data || {};
			// data.item.length = 0;
			if(data.item.length < 1){
				$('.right-cont .guest-part').css('display', 'none');
			}

			$('.right-cont .guest').biliSlider({
				data: data.item,
				type: 'gallery',
				timeout:0,
				onRender:function(wrapper, data, index){
					var block = '<div class="intro">\
									<p class="intro-p1">tgs：<span class="video-name">'+data.title+'</span></p>\
									<p class="intro-p2">UP：<span class="up-name">'+data.link+'</span></p>\
								</div>';
					var slider_li = $(wrapper).find('.slider-list-wrapper').find('li[index=' + index + ']');
					slider_li.append(block);
					slider_li.attr('data-aid', data.width);
					slider_li.find('img').attr('data-aid', data.width);

					var text = '<p class="name">'+data.link+'</p>';
					$(wrapper).find('.s-bottom').find('li[index=' + index + ']').append(text);
				},
			    slideCallback: function(wrapper, index) {
			        var sbar = $('.slider-bar',wrapper),
						box = $('.slider-bar li',wrapper),
						thisBox = box.eq(index),
						boxWidth = box.width();

			        if (thisBox.position().left > 0) {
			            sbar.css('left','-' + thisBox.position().left + 'px');
			        }
			    }
			});

			var arrow = $('.right-cont .guest').find('.slider-prev,.slider-next');
			if(data.item.length <= 1){
				arrow.css('display', 'none');
			}else{
				arrow.css('display', 'block');
			}

		}
	})







/** WEBPACK FOOTER **
 ** ./src/js/compontents/slider.js
 **/